import ChatIcon from 'components/Common/Icons/ChatIcon/ChatIcon';
import DataSearchIcon from 'components/Common/Icons/DataSearchIcon/DataSearchIcon';
// import FileIcon from 'components/Common/Icons/FileIcon/FileIcon';
import HandCoinsIcon from 'components/Common/Icons/HandCoinsIcon/HandCoinsIcon';
import MyDealsIcon from 'components/Common/Icons/MyDealsIcon/MyDealsIcon';
import QuestionMarkIcon from 'components/Common/Icons/QuestionMarkIcon/QuestionMarkIcon';
import StorageProvidersIcon from '../components/Common/Icons/StorageProvidersIcon/StorageProvidersIcon';
import { ROUTES } from './routes';

export const DASHBOARD_CLIENT_LINKS = [
  {
    label: 'messages',
    route: ROUTES.DASHBOARD.CHAT,
    Icon: ChatIcon,
    iconClass: 'chat-icon',
  },
  {
    label: 'myDeals',
    route: ROUTES.DASHBOARD.MY_DEALS,
    Icon: MyDealsIcon,
    iconClass: 'deals-icon',
  },
  // {
  //   label: 'myFiles',
  //   route: ROUTES.DASHBOARD.MY_FILES,
  //   Icon: FileIcon,
  //   iconClass: 'files-icon',
  // },
];

export const DASHBOARD_STORAGE_PROVIDER_LINKS = [
  {
    label: 'messages',
    route: ROUTES.DASHBOARD.CHAT,
    Icon: ChatIcon,
    iconClass: 'chat-icon',
  },
  {
    label: 'myDeals',
    route: ROUTES.DASHBOARD.MY_DEALS,
    Icon: MyDealsIcon,
    iconClass: 'deals-icon',
  },
  {
    label: 'filmine',
    route: ROUTES.DASHBOARD.FILMINE,
    Icon: HandCoinsIcon,
    iconClass: 'allowance-icon',
  },
  // {
  //   label: 'myFiles',
  //   route: ROUTES.DASHBOARD.MY_FILES,
  //   Icon: FileIcon,
  //   iconClass: 'files-icon',
  // },
  {
    label: 'myProfiles',
    route: ROUTES.DASHBOARD.MY_PROFILES,
    iconClass: 'storage-provider-icon',
    Icon: StorageProvidersIcon,
  },
];

export const DASHBOARD_COMMON_LINKS = [
  {
    label: 'exploreSPs',
    route: ROUTES.EXPLORE,
    Icon: DataSearchIcon,
    iconClass: 'data-search-icon',
  },
  {
    label: 'howTo',
    route: ROUTES.DASHBOARD.HOW_TO.STORE,
    Icon: QuestionMarkIcon,
    iconClass: 'question-mark-icon',
  },
];

export const TRUNCATED_ADDRESS_LENGTH = 24;

export const DEFAULT_STORAGE_PROVIDER_ROUTE = ROUTES.DASHBOARD.MY_PROFILES;
export const DEFAULT_ROUTE = ROUTES.DASHBOARD.MY_DEALS;

export const DEFAULT_AVATAR_CODE = '04';

export const TIB_IN_BYTES = 1099511627776;

export const CLIENT_ROLE_LINKS = [
  // ROUTES.DASHBOARD.MY_FILES,
  ROUTES.DASHBOARD.CONNECTED_ADDRESSES,
  ROUTES.DASHBOARD.ACCOUNT_SETTINGS,
  ROUTES.DASHBOARD.STORAGE_REQUESTS,
  ROUTES.DASHBOARD.MY_DEALS,
  ROUTES.DASHBOARD.CHAT,
  ROUTES.DASHBOARD.HOW_TO.API_REFERENCE,
  ROUTES.DASHBOARD.HOW_TO.CONNECTING_YOUR_MINERS,
  ROUTES.DASHBOARD.HOW_TO.LISTING,
  ROUTES.DASHBOARD.HOW_TO.MINERS_DASHBOARD,
  ROUTES.DASHBOARD.HOW_TO.RETRIEVE,
  ROUTES.DASHBOARD.HOW_TO.STORE,
];

export const STORAGE_PROVIDER_ROLE_LINKS = [
  ROUTES.DASHBOARD.CONNECTED_ADDRESSES,
  ROUTES.DASHBOARD.ACCOUNT_SETTINGS,
  ROUTES.DASHBOARD.STORAGE_REQUESTS,
  ROUTES.DASHBOARD.FILMINE,
  ROUTES.DASHBOARD.MY_DEALS,
  ROUTES.DASHBOARD.MY_PROFILES,
  ROUTES.DASHBOARD.CHAT,
  ROUTES.DASHBOARD.HOW_TO.API_REFERENCE,
  ROUTES.DASHBOARD.HOW_TO.CONNECTING_YOUR_MINERS,
  ROUTES.DASHBOARD.HOW_TO.LISTING,
  ROUTES.DASHBOARD.HOW_TO.MINERS_DASHBOARD,
  ROUTES.DASHBOARD.HOW_TO.RETRIEVE,
  ROUTES.DASHBOARD.HOW_TO.STORE,
];

export const PROTECTED_ROLE_LINKS = [
  ROUTES.DASHBOARD.FILMINE,
  ROUTES.DASHBOARD.MY_PROFILES,
];
